import { Brain, HeartPlus, Smile } from "lucide-react";

const BRAIN_STEPS = [
  {
    name: "CHECK IN",
    brainPart: "Brain Stem",
    imageSrc: "images/brain/BrainBlue1.jpg",
    imageAlt: "Check In brain step",
    icon: Smile,
  },
  {
    name: "BE MINDFUL",
    brainPart: "Midbrain",
    imageSrc: "images/brain/BrainBlue2.jpg",
    imageAlt: "Be Mindful brain step",
    icon: Brain,
  },
  {
    name: "PRACTICE",
    brainPart: "Cortex",
    imageSrc: "images/brain/BrainBlue3.jpg",
    imageAlt: "Practice brain step",
    icon: HeartPlus,
  },
];

export default function BrainModelSection({ section }) {
  return (
    <section id={section.id} className="mt-8 scroll-mt-24">
      <h2 className="m-0 text-base font-semibold text-[#1E2D3D] sm:text-lg">
        {section.title}
      </h2>
      {section.description && (
        <p className="m-0 mt-1 text-sm text-[#555555] sm:text-base">
          {section.description}
        </p>
      )}

      <div className="mx-auto mt-4 w-full max-w-3xl rounded-lg border border-[#DDDDDD] bg-white p-4 sm:p-6">
        <div className="flex w-full flex-col items-center gap-4">
          <div className="flex flex-col gap-4 rounded bg-[#F7FAFD] px-4 py-4 sm:flex-row sm:items-center sm:gap-6 sm:px-6 sm:py-5">
            <img
              src="images/brain/brain3colors.webp"
              alt="Brain"
              className="h-auto w-40 flex-shrink-0 self-center sm:w-64"
            />
            <p className="m-0 text-sm text-[#1E2D3D] sm:text-base">
              1-2-3 Wellness can help you move up your brain to learn and grow!
              <br />
              <br />
              <strong>Regulate:</strong> Learn how to calm your mind and body.
              <br />
              <strong>Relate:</strong> Learn how to connect with others, and
              your environment.
              <br />
              <strong>Reason:</strong> Choose a wellness practice to get ready
              to learn!
            </p>
          </div>

          <div className="grid w-full grid-cols-1 gap-4 sm:gap-6 md:grid-cols-3">
            {BRAIN_STEPS.map((step, index) => (
              <div
                key={step.name}
                className="flex flex-col items-center gap-2 rounded bg-[#F9FAFB] px-5 py-4 sm:px-8 sm:py-5"
              >
                <div className="relative">
                  <img
                    src={step.imageSrc}
                    alt={step.imageAlt}
                    className="h-auto w-24 flex-shrink-0 rounded object-cover"
                  />
                  <div className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-[#3387CF] text-sm font-bold text-white shadow-sm">
                    {index + 1}
                  </div>
                </div>
                <div className="flex items-center justify-center gap-1 font-semibold">
                  <step.icon className="h-[14px] w-[14px] shrink-0" />
                  <span className="text-xs sm:text-sm">{step.name}</span>
                </div>
                <p className="m-0 text-sm text-[#555555] sm:text-base">
                  {step.brainPart}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
